<div class="container">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li *ngFor="let item of items; let last = last" class="breadcrumb-item" [class.active]="item.active">
                <span *ngIf="item.active">{{ item.label }}</span>

                <button *ngIf="!item.active" class="btn btn-outline-primary" (click)="navigateTo(item.route)">
                    {{ item.label }}
                </button>
            </li>
        </ol>
    </nav>
</div>
